import { AdminListingRequestDtoDummy } from 'dummies/AdminListingRequestDummy';
import { convertModel } from 'libs/helper/modelHelper';
import { toast } from 'react-toastify';
import { AdminListingDto, AdminListingRequestDto } from 'services/data-contracts';

import ServiceHelper from 'stores/ServiceHelper';

export const saveListing = async (listing: AdminListingDto) => {
  console.log('listing22', listing);
  const newModel = convertModel<AdminListingRequestDto>(listing, AdminListingRequestDtoDummy);
  const result = await ServiceHelper.adminListingService?.updateListing(listing?.id as number, {
    ...newModel,
    latitude: newModel.latitude || 0,
    longitude: newModel.longitude || 0,
  });

  if (result?.status === 200) {
    toast.success('저장되었습니다.');
    return result.data;
  } else {
    toast.error('저장에 실패했습니다.');
  }
};
